import Axios from "axios";
import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import AppConfig from "../../../../../config/AppConfig";
class ChartSebaranSPMIBerdasarkanWilayah extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jenis_pendidikan: [],
      label: [],
      penetapan_standar: [],
      peningkatan_standar: [],
      pengendalian_hasil_evaluasi: [],
      evaluasi_pelaksanaan: [],
      loading: false,
    };
  }

  options = {
    indexAxis: "y",
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
  };
  getData() {
    this.setState({
      loading: true,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata) {
      session =
        "?tipe_lembaga=" +
        this.props.tipe_lembaga +
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let i = 0;
    let labels = [];
    let penetapan_standar = [];
    let peningkatan_standar = [];
    let pengendalian_hasil_evaluasi = [];
    let evaluasi_pelaksanaan = [];
    Axios.get(AppConfig.DetailDashboard + "sebaranspmibyjenis" + session)
      .then((res) => {
        for (var key in res.data.result.data_vokasi) {
          labels[i] = key;
          penetapan_standar[i] = res.data.result.data_vokasi[key].penetapan_standar;
          peningkatan_standar[i] =
            res.data.result.data_vokasi[key].peningkatan_standar;
          pengendalian_hasil_evaluasi[i] =
            res.data.result.data_vokasi[key].pengendalian_hasil_evaluasi;
          evaluasi_pelaksanaan[i] =
            res.data.result.data_vokasi[key].evaluasi_pelaksanaan;
          i = i + 1;
        }

        this.setState({
          label: labels,
          penetapan_standar: penetapan_standar,
          peningkatan_standar: peningkatan_standar,
          pengendalian_hasil_evaluasi: pengendalian_hasil_evaluasi,
          evaluasi_pelaksanaan: evaluasi_pelaksanaan,
          loading: false,
        });
      })
      .catch((err) => {
        alert("not found");
      });
  }
  async componentDidMount() {
    this.getData();
  }
  async componentDidUpdate() {
    if (this.props.status === true) {
      this.getData();
      this.props.parentCallback(false);
    }
  }
  render() {
    let datas = {
      labels: this.state.label,
      datasets: [
        {
          label: "Penetapan Standar",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#4472C4",
          borderColor: "#4472C4",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#4472C4",
          pointBackgroundColor: "#4472C4",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#4472C4",
          pointHoverBorderColor: "#4472C4",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.penetapan_standar,
        },
        {
          label: "Evaluasi Pelaksanaan",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#ED7D39",
          borderColor: "#ED7D39",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#ED7D39",
          pointBackgroundColor: "#ED7D39",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#ED7D39",
          pointHoverBorderColor: "#ED7D39",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.evaluasi_pelaksanaan,
        },
        {
          label: "Pengendalian Hasil Evaluasi",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#F8C145",
          borderColor: "#F8C145",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#F8C145",
          pointBackgroundColor: "#F8C145",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#F8C145",
          pointHoverBorderColor: "#F8C145",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.pengendalian_hasil_evaluasi,
        },
        {
          label: "Peningkatan Standar",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#5B9BD5",
          borderColor: "#5B9BD5",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#5B9BD5",
          pointBackgroundColor: "#5B9BD5",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#5B9BD5",
          pointHoverBorderColor: "#5B9BD5",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.peningkatan_standar,
        },
      ],
    };
    return (
      <>
        {this.state.loading === true ? (
          <span className="ml-3 spinner spinner-black"></span>
        ) : (
          <Bar data={datas} options={this.options} />
        )}
      </>
    );
  }
}
export default ChartSebaranSPMIBerdasarkanWilayah;
